import React, { useRef } from "react";
import { FaCode, FaServer, FaCloud, FaCheckCircle } from "react-icons/fa";
import webDesignGif from "../assests/web design.gif";
import dataSecurityGif from "../assests/DATA SECURITY.gif";
import apiIntegrationGif from "../assests/API Integration.gif";
import hostingGif from "../assests/Hosting.gif";

const items = [
  {
    icon: <FaCode size={32} className="text-cyan-400" />,
    title: "Frontend Development",
    desc: [
      "Building complex, interactive user interfaces using React.js.",
      "Developing large-scale web applications with state management libraries such as Redux.",
      "Creating responsive web applications for all devices.",
      "Implementing modern UI/UX best practices."
    ],
    gif: webDesignGif,
  },
  {
    icon: <FaServer size={32} className="text-cyan-400" />,
    title: "Backend Development",
    desc: [
      "Designing scalable RESTful APIs and server logic with Node.js & Express.",
      "Implementing authentication, authorization, and security best practices.",
      "Integrating with SQL & NoSQL databases.",
      "Optimizing performance and reliability for production."
    ],
    gif: apiIntegrationGif,
  },
  {
    icon: <FaCloud size={32} className="text-cyan-400" />,
    title: "Cloud Solutions",
    desc: [
      "Deploying and scaling apps on AWS, Azure, and serverless platforms."
    ],
    gif: hostingGif,
  },
];

const WhatIDo = () => {
  const headingRef = useRef(null);
  return (
    <section className="w-full py-8 md:py-16 bg-white dark:bg-[#232946] flex flex-col items-center px-4" id="what-i-do">
      <h2 ref={headingRef} className="text-3xl md:text-5xl font-bold mb-4 text-white animated-gradient-text text-center">What I do</h2>
      <p className="text-base md:text-lg text-black dark:text-cyan-300 mb-6 md:mb-10 text-center max-w-2xl px-4">
        I help businesses and individuals bring their ideas to life with modern web technologies, scalable cloud solutions, and beautiful user experiences.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full max-w-6xl">
        {items.map((item, index) => {
          const stickyColors = [
            { bg: 'bg-yellow-100 dark:bg-yellow-200', shadow: 'shadow-yellow-400/40', tape: 'bg-yellow-300/60' },
            { bg: 'bg-pink-100 dark:bg-pink-200', shadow: 'shadow-pink-400/40', tape: 'bg-pink-300/60' },
            { bg: 'bg-blue-100 dark:bg-blue-200', shadow: 'shadow-blue-400/40', tape: 'bg-blue-300/60' }
          ];
          const color = stickyColors[index % 3];
          
          return (
            <div key={item.title} className="whatido-card group transition h-[26rem] md:h-[32rem] duration-300" style={{ transform: 'rotate(0.5deg)' }}>
              <div className="whatido-card-inner w-full h-full">
                <div className={`whatido-card-front relative ${color.bg} shadow-lg hover:${color.shadow} hover:shadow-2xl transition-all duration-300`} style={{
                  clipPath: 'polygon(0% 2%, 2% 0%, 5% 1%, 8% 0%, 12% 2%, 15% 0%, 18% 1%, 22% 0%, 25% 2%, 28% 1%, 32% 0%, 35% 2%, 38% 0%, 42% 1%, 45% 0%, 48% 2%, 52% 1%, 55% 0%, 58% 2%, 62% 0%, 65% 1%, 68% 0%, 72% 2%, 75% 1%, 78% 0%, 82% 2%, 85% 0%, 88% 1%, 92% 0%, 95% 2%, 98% 1%, 100% 0%, 100% 3%, 99% 6%, 100% 9%, 99% 12%, 100% 15%, 99% 18%, 100% 22%, 99% 25%, 100% 28%, 99% 32%, 100% 35%, 99% 38%, 100% 42%, 99% 45%, 100% 48%, 99% 52%, 100% 55%, 99% 58%, 100% 62%, 99% 65%, 100% 68%, 99% 72%, 100% 75%, 99% 78%, 100% 82%, 99% 85%, 100% 88%, 99% 92%, 100% 95%, 99% 98%, 100% 100%, 98% 99%, 95% 100%, 92% 99%, 88% 100%, 85% 99%, 82% 100%, 78% 99%, 75% 100%, 72% 99%, 68% 100%, 65% 99%, 62% 100%, 58% 99%, 55% 100%, 52% 99%, 48% 100%, 45% 99%, 42% 100%, 38% 99%, 35% 100%, 32% 99%, 28% 100%, 25% 99%, 22% 100%, 18% 99%, 15% 100%, 12% 99%, 8% 100%, 5% 99%, 2% 100%, 0% 98%, 1% 95%, 0% 92%, 1% 88%, 0% 85%, 1% 82%, 0% 78%, 1% 75%, 0% 72%, 1% 68%, 0% 65%, 1% 62%, 0% 58%, 1% 55%, 0% 52%, 1% 48%, 0% 45%, 1% 42%, 0% 38%, 1% 35%, 0% 32%, 1% 28%, 0% 25%, 1% 22%, 0% 18%, 1% 15%, 0% 12%, 1% 8%, 0% 5%, 1% 2%)'
                }}>
                  <div className="absolute top-2 left-1/2 -translate-x-1/2 z-30">
                    <div className="relative w-6 h-6 bg-gradient-to-br from-red-500 to-red-600 rounded-full shadow-lg border-2 border-red-700">
                      <div className="absolute top-1 left-1 w-2 h-2 bg-white/40 rounded-full"></div>
                    </div>
                    <div className="absolute top-5 left-1/2 -translate-x-1/2 w-0.5 h-3 bg-gradient-to-b from-gray-400 to-gray-500 shadow-sm"></div>
                  </div>
                  
                  <div className="absolute inset-0 opacity-5 bg-[repeating-linear-gradient(0deg,transparent,transparent_2px,rgba(0,0,0,0.1)_2px,rgba(0,0,0,0.1)_4px)]"></div>
                  
                  <div className="absolute inset-0 shadow-[inset_0_0_8px_rgba(0,0,0,0.1)]"></div>
                  
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-3 md:mb-4 mt-6 md:mt-8 px-4 relative z-10 font-handwriting">{item.title}</h3>
                  <div className="mb-4 md:mb-5 relative z-10 transition-transform duration-300 hover:scale-110 text-gray-700">{item.icon}</div>
                  {item.gif && (
                    <img src={item.gif} alt={item.title + ' gif'} className="mt-2 w-full max-h-40 md:max-h-48 object-contain rounded-lg shadow-md relative z-10 transition-all duration-300 hover:shadow-xl px-2" />
                  )}
                </div>
                <div className={`whatido-card-back w-full flex flex-col gap-3 px-4 md:px-5 py-5 overflow-y-auto justify-center ${color.bg} shadow-2xl relative`} style={{
                  clipPath: 'polygon(0% 2%, 2% 0%, 5% 1%, 8% 0%, 12% 2%, 15% 0%, 18% 1%, 22% 0%, 25% 2%, 28% 1%, 32% 0%, 35% 2%, 38% 0%, 42% 1%, 45% 0%, 48% 2%, 52% 1%, 55% 0%, 58% 2%, 62% 0%, 65% 1%, 68% 0%, 72% 2%, 75% 1%, 78% 0%, 82% 2%, 85% 0%, 88% 1%, 92% 0%, 95% 2%, 98% 1%, 100% 0%, 100% 3%, 99% 6%, 100% 9%, 99% 12%, 100% 15%, 99% 18%, 100% 22%, 99% 25%, 100% 28%, 99% 32%, 100% 35%, 99% 38%, 100% 42%, 99% 45%, 100% 48%, 99% 52%, 100% 55%, 99% 58%, 100% 62%, 99% 65%, 100% 68%, 99% 72%, 100% 75%, 99% 78%, 100% 82%, 99% 85%, 100% 88%, 99% 92%, 100% 95%, 99% 98%, 100% 100%, 98% 99%, 95% 100%, 92% 99%, 88% 100%, 85% 99%, 82% 100%, 78% 99%, 75% 100%, 72% 99%, 68% 100%, 65% 99%, 62% 100%, 58% 99%, 55% 100%, 52% 99%, 48% 100%, 45% 99%, 42% 100%, 38% 99%, 35% 100%, 32% 99%, 28% 100%, 25% 99%, 22% 100%, 18% 99%, 15% 100%, 12% 99%, 8% 100%, 5% 99%, 2% 100%, 0% 98%, 1% 95%, 0% 92%, 1% 88%, 0% 85%, 1% 82%, 0% 78%, 1% 75%, 0% 72%, 1% 68%, 0% 65%, 1% 62%, 0% 58%, 1% 55%, 0% 52%, 1% 48%, 0% 45%, 1% 42%, 0% 38%, 1% 35%, 0% 32%, 1% 28%, 0% 25%, 1% 22%, 0% 18%, 1% 15%, 0% 12%, 1% 8%, 0% 5%, 1% 2%)'
                }}>
                  <div className="absolute inset-0 opacity-5 bg-[repeating-linear-gradient(0deg,transparent,transparent_2px,rgba(0,0,0,0.1)_2px,rgba(0,0,0,0.1)_4px)]"></div>
                  
                  <div className="absolute inset-0 shadow-[inset_0_0_8px_rgba(0,0,0,0.1)]"></div>
                  
                  {Array.isArray(item.desc) ? (
                    item.desc.map((text, idx) => (
                      <div key={idx} className="flex items-center gap-3 bg-white/60 dark:bg-white/50 rounded-md px-3 md:px-4 py-3 shadow-md border-l-4 border-gray-800 relative z-10">
                        <FaCheckCircle className="text-green-700 flex-shrink-0" size={18} />
                        <span className="text-sm md:text-base text-gray-900 text-left leading-relaxed font-bold">{text}</span>
                      </div>
                    ))
                  ) : (
                    <span className="text-sm md:text-base text-gray-900 text-left font-bold">{item.desc}</span>
                  )}
                  
                  <div className="absolute bottom-0 right-0 w-0 h-0 border-l-[30px] border-l-transparent border-b-[30px] border-b-gray-400/20 z-20"></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhatIDo; 